import React from 'react';

import { InputField } from 'basics';
import { Caption } from 'basics/styles';

import { StagesRow } from './styles';

export default function CompetitionForm({register, setValue, errors, item})
{
	return (
		<>
			<InputField
				label="Año"
				type="number"
				value={item && item.title}
				id="title"
				register={register}
				error={errors.title}
				mode="dark"
				required={true}
			/>

			{/* Las fechas públicas: la home abre y cierra la postulación con las dos
			    primeras, y la última es la de la entrega de premios (a partir de ahí
			    la competición se da por terminada). */}
			<Caption mode="dark">Fechas públicas</Caption>

			<StagesRow>
				<InputField
					label="Apertura de postulaciones"
					type="date"
					value={item && item.entryStage}
					id="entryStage"
					register={register}
					error={errors.entryStage}
					mode="dark"
					width="100%"
					required={true}
				/>

				<InputField
					label="Cierre de postulaciones"
					type="date"
					value={item && item.selectionStage}
					id="selectionStage"
					register={register}
					error={errors.selectionStage}
					mode="dark"
					width="100%"
					required={true}
				/>

				<InputField
					label="Entrega de premios"
					type="date"
					value={item && item.judgingStage}
					id="judgingStage"
					register={register}
					error={errors.judgingStage}
					mode="dark"
					width="100%"
					required={true}
				/>
			</StagesRow>

			{/* Las internas sólo se muestran en el gráfico del proceso, que ven
			    administración, seleccionadores y jurado. Son opcionales: sin ellas
			    el gráfico no muestra fecha en ese paso. */}
			<Caption mode="dark">Fechas internas del proceso</Caption>

			<StagesRow>
				<InputField
					label="Comité de postulaciones (curaduría)"
					type="date"
					value={item && item.curationStage}
					id="curationStage"
					register={register}
					error={errors.curationStage}
					mode="dark"
					width="100%"
				/>

				<InputField
					label="Comunicación a finalistas"
					type="date"
					value={item && item.finalistsStage}
					id="finalistsStage"
					register={register}
					error={errors.finalistsStage}
					mode="dark"
					width="100%"
				/>
			</StagesRow>

			<StagesRow>
				<InputField
					label="Inicio de la votación"
					type="date"
					value={item && item.votingStartStage}
					id="votingStartStage"
					register={register}
					error={errors.votingStartStage}
					mode="dark"
					width="100%"
				/>

				<InputField
					label="Cierre de la votación"
					type="date"
					value={item && item.votingEndStage}
					id="votingEndStage"
					register={register}
					error={errors.votingEndStage}
					mode="dark"
					width="100%"
				/>
			</StagesRow>

			{/* Video de fondo del hero de la home. Si queda vacío, `MainVideo` cae
			    en el video por defecto compilado en el bundle. */}
			<InputField
				label="Video de la home (link de YouTube)"
				type="text"
				value={item && item.videoUrl}
				id="videoUrl"
				register={register}
				error={errors.videoUrl}
				mode="dark"
				placeholder="https://www.youtube.com/watch?v=..."
				width="100%"
			/>
		</>
	)
}
